import initProducts from "./components/products.js";
import "./components/mouse.js";
import "./components/modal.js";
import initSliders from "./components/sliders.js";
import "./components/matter.js";
import "./components/cards.js";
import initHeader from "./components/header.js";
import initDelivery from "./components/delivery.js";
import initRomb from "./components/romb.js";
import initAOS from "./components/aos.js";
import "./components/faq.js";
import "./components/plans.js";
import "./components/validation.js";
import initLoyalItems from "./components/loyal-items.js";
import initLazyLoad from "./components/lazyImages.js";
import initDeferredLoading from "./components/deferred-loading.js";
import "./components/anchor-links.js";

// Экспортируем все функции инициализации
export {
  initProducts,
  initSliders,
  initHeader,
  initDelivery,
  initRomb,
  initAOS,
  initLoyalItems,
  initLazyLoad,
  initDeferredLoading,
};
